<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Reminders</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)" color="primary">
    <ion-refresher-content pullingText="Pull to refresh" refreshingSpinner="circular" refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <ion-segment value="All" [(ngModel)]="filter" (ionChange)="filterReminders()">
      <ion-segment-button value="Active">
        <ion-label>Active</ion-label>
      </ion-segment-button>
      <ion-segment-button value="Complete">
        <ion-label>Complete</ion-label>
      </ion-segment-button>
    </ion-segment>
    <ion-grid>
      <ion-row>
        <ion-col sizeXl="10" offsetXl="1">
          <div style="border-bottom: 1px solid #c3c3c3">
            <ion-chip tappable (click)="setDogFilter('All')"
              [ngStyle]="{'background-color':dogfilter === 'All' ? '#16a5d4' : '' }">All Dogs</ion-chip><ion-chip
              *ngFor="let i of dogFilterArray" (click)="setDogFilter(i)" tappable
              [ngStyle]="{'background-color':dogfilter === i ? '#16a5d4' : '' }">{{i}}</ion-chip>
          </div>
          <div class="ion-padding ion-text-center" *ngIf="loadedReminders.length ===0">
            <ion-text color="darkmimbo">There are no {{filter!=='All' ? filter.toLowerCase()+' ' :
              ''}}reminders {{dogfilter!=='All' ? 'for ' + dogfilter +' ' :
              ''}}</ion-text>
          </div>
          <div *ngIf="loadedReminders.length >0">
            <ion-list>
              <ion-item-sliding *ngFor="let reminder of loadedReminders">
                <ion-item detail [routerLink]="'addit-reminders/' + reminder.id" color="lightmimbo">
                  <ion-avatar class="avatar-img">
                    <img alt="Reminder Type" [src]="'../../../assets/images/remindertypes/' + reminder.typeImageName" />
                  </ion-avatar>
                  <div>
                    <p class="info">
                      {{formatDateTime(reminder.reminderDateTime)}}
                    </p>
                    <p class="info">{{reminder.dogName}}</p>
                    <p class="info" *ngIf="!reminder.customName || reminder.customName.trim().length==0">
                      {{getTypeName(reminder.typeId)}}
                    </p>
                    <p class="info" *ngIf="reminder.customName && reminder.customName.trim().length>0">
                      {{reminder.customName}}
                    </p>
                  </div>
                </ion-item>
                <ion-item-options>
                  <ion-item-option color="danger" (click)="deleteReminder(reminder.id)"><ion-icon name="trash-outline"
                      slot="start"></ion-icon>Delete</ion-item-option>
                </ion-item-options>
              </ion-item-sliding>
            </ion-list>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-fab-button routerLink="addit-reminders"><ion-icon name="add-outline"
        class="add-outline"></ion-icon></ion-fab-button>
  </div>
</ion-content>